import { CheckCircle2 } from "lucide-react";

const points = [
  "SEO, AEO & GEO strategy that compounds over time",
  "Paid ads across Google, Meta and LinkedIn",
  "Email, content and lifecycle marketing",
  "AI-powered marketing automation & analytics",
];

export default function About() {
  return (
    <section id="about" className="bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6 reveal">
          <div className="text-xs font-bold uppercase tracking-widest text-blue-600">About</div>
          <h2 className="mt-3 font-display text-3xl md:text-5xl font-bold text-slate-900 tracking-tight">
            6+ years helping businesses turn marketing into measurable growth.
          </h2>
          <p className="mt-5 text-slate-600 text-base md:text-lg leading-relaxed">
            I&apos;m Vipul Saxena, founder of <span className="font-semibold text-slate-900">The AI Growth Pilot</span> — a digital marketing and SEO professional
            with 6+ years of hands-on experience across SEO, AEO, GEO, Google Ads, Meta Ads, LinkedIn marketing,
            email marketing, content strategy, analytics and AI automation. I combine data, creativity and modern
            automation tools to help businesses grow visibility, generate qualified leads and improve conversions.
          </p>

          <ul className="mt-8 space-y-3">
            {points.map((p) => (
              <li key={p} className="flex items-start gap-3 text-slate-700">
                <CheckCircle2 className="w-5 h-5 text-blue-600 mt-0.5 shrink-0" />
                <span>{p}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-6 reveal">
          <div className="relative rounded-3xl overflow-hidden border border-slate-200 shadow-xl">
            <img
              src="https://images.unsplash.com/photo-1560250163-17506787d971?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMG93bmVyJTIwbWVldGluZ3xlbnwwfHx8Ymx1ZXwxNzgzMzQzNTc3fDA&ixlib=rb-4.1.0&q=85"
              alt="Professional business consultation"
              loading="lazy"
              className="w-full h-[380px] md:h-[520px] object-cover"
            />
            <div className="absolute bottom-4 left-4 right-4 bg-white/95 backdrop-blur-md rounded-2xl border border-slate-100 p-4 md:p-5 shadow-lg">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-xl bg-slate-900 text-white grid place-items-center font-display font-bold text-lg">
                  VS
                </div>
                <div>
                  <div className="font-display font-bold text-slate-900">Vipul Saxena</div>
                  <div className="text-xs md:text-sm text-slate-600">
                    Founder, The AI Growth Pilot • 6+ Years Experience
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
